import React from 'react'

const SubscriptionConfirmation = () => {
  
  return (
  <>
  <h1>SubscriptionConfirmation</h1>
  </>
  )
}

export default SubscriptionConfirmation